import type en from "../en/aiadmin";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  statusVoices: "أصوات المكالمات الطبيعية (مختبر الأصوات)",
  statusVoicesHint: "قارن أصوات ElevenLabs وHakim وGemini وCartesia وOpenAI واختر صوتًا لكل لهجة وجنس. بدونه تستخدم المكالمات أصوات المتصفح.",
  personaPortraits: "صور شخصيات المكالمات الذكية (Flux)",
  metaTitle: "الذكاء الاصطناعي والأرصدة",
  title: "الذكاء الاصطناعي والأرصدة",
  description: "حدّد ميزات الذكاء الاصطناعي المجانية، وتكلفتها بالأرصدة، وما تتضمنه كل باقة شهريًا، وحزم الأرصدة التي يمكن للتجار شراؤها.",

  statusTitle: "الحالة",
  statusDesc: "تُضبط التكاملات عبر متغيرات البيئة على الخادم. لا تُعرض القيم السرية هنا أبدًا.",
  statusConfigured: "مُعدّ",
  statusMissing: "غير مُعدّ",
  statusClaude: "ذكاء النصوص — OpenAI GPT أو Claude (الطلبات، المكالمات، الترجمة)",
  statusClaudeHint: "يستخدم OpenAI عند حفظ مفتاح OpenAI في مختبر الأصوات ← المزوّدون (أو ضبط {vars})، وإلا فـ Claude عبر ANTHROPIC_API_KEY.",
  statusImages: "صور الذكاء الاصطناعي (Flux)",
  imagesFlux: "Flux عبر Replicate يُنشئ صور المتاجر.",
  imagesOpenai: "لا يوجد رمز Replicate: تُستخدم صور OpenAI (بمفتاح OpenAI). أضف رمز Replicate لاستخدام Flux.",
  imagesNone: "أضف رمز Replicate (Flux) أو مفتاح OpenAI في مختبر الأصوات لإنشاء صور المنتجات.",
  imageKeyLabel: "رمز API لـ Replicate",
  imageKeySavedPlaceholder: "الرمز محفوظ — الصق رمزًا جديدًا لاستبداله",
  imageKeySave: "حفظ الرمز",
  imageKeyRemove: "حذف الرمز المحفوظ",
  imageKeyHelp: "احصل عليه من replicate.com ← Account ← API tokens. يُخزَّن مشفّرًا ولا يُعرض مجددًا.",
  imageTest: "اختبار توليد الصور",
  imageTestOk: "{provider} يعمل: تم إنشاء صورة اختبار ({kb} ك.ب في {s} ث).",
  imageTestFailed: "فشل {provider}: {error}",
  imageKeySaved: "تم حفظ رمز الصور.",
  imageKeyRemoved: "تم حذف رمز الصور.",
  statusImagesHint: "اضبط {vars}.",
  statusStripe: "Stripe المنصة (شراء الأرصدة)",
  statusStripeHint: "اضبط {vars}. بدونه لا يستطيع التجار شراء الأرصدة عبر الإنترنت — ويمكنك دائمًا منح الأرصدة يدويًا.",
  statusWebhookMissing: "سر الـ webhook مفقود: لن تُضاف المشتريات إلا عند عودة المشتري إلى الموقع.",

  usageTitle: "الاستخدام والإيرادات",
  statSold: "الأرصدة المباعة",
  statRevenue: "إيرادات الأرصدة",
  statSpent: "الأرصدة المستهلكة",
  statOutstanding: "الأرصدة غير المستخدمة",
  statOutstandingSub: "مجموع كل الأرصدة",
  statPrompts: "طلبات الذكاء الاصطناعي",
  statMinutes: "دقائق المكالمات",
  statImages: "صور الذكاء الاصطناعي",
  statThisMonth: "هذا الشهر",
  statAllTime: "منذ البداية",

  pricingTitle: "مجاني أم مدفوع",
  pricingDesc: "الميزات المجانية لا تستهلك أرصدة أبدًا. الميزات المدفوعة تستخدم أولًا الحصة الشهرية المضمّنة في باقة التاجر، ثم الأرصدة.",
  feature_prompt: "طلبات الذكاء الاصطناعي",
  feature_call: "المكالمات الصوتية",
  feature_image: "صور الذكاء الاصطناعي",
  feature_translation: "الترجمة بالذكاء الاصطناعي",
  featureDesc_prompt: "الطلبات الموجّهة إلى مساعد المتجر الذكي.",
  featureDesc_call: "مكالمات صوتية مباشرة مع المساعد الذكي.",
  featureDesc_image: "صور المنتجات واللافتات المُولّدة.",
  featureDesc_translation: "الترجمة التلقائية لمحتوى المتجر.",
  modeFree: "مجاني للجميع",
  modeMetered: "مدفوع — حصة الباقة ثم الأرصدة",
  cost_prompt: "الأرصدة لكل طلب (المستوى المتوسط)",
  cost_call: "الأرصدة لكل دقيقة (المستوى المتوسط)",
  cost_image: "الأرصدة لكل صورة",
  cost_translation: "الأرصدة لكل عنصر",
  costHintLevel: "تُضرب في مُعامل سعر المستوى.",
  costHintNoAllowance: "لا تتضمن الباقات حصة ترجمة مجانية: تُخصم الأرصدة من العنصر الأول.",
  signupCredits: "أرصدة مكافأة التسجيل",
  signupCreditsHint: "تُمنح مرة واحدة لكل حساب جديد.",
  lowBalance: "تنبيه انخفاض الرصيد",
  lowBalanceHint: "يُنبَّه التجار عندما ينخفض رصيدهم عن هذا العدد من الأرصدة.",

  levelsTitle: "مستويات النموذج",
  levelsDesc: "يرتبط كل مستوى بنموذج ودرجة جهد. استخدم نماذج OpenAI (gpt-5-mini، gpt-5…) أو Claude (claude-haiku-5-5…). إذا كان نموذج المستوى تابعًا للمزوّد غير النشط، يُستخدم النموذج الافتراضي للمزوّد النشط (منخفض/متوسط: gpt-5-mini، عالٍ/أقصى: gpt-5). يضبط مُعامل السعر تكلفة الأرصدة.",
  level_low: "منخفض",
  level_medium: "متوسط",
  level_high: "عالٍ",
  level_max: "أقصى",
  colLevel: "المستوى",
  colEnabled: "مفعّل",
  colModel: "النموذج",
  colEffort: "الجهد",
  colMultiplier: "مُعامل السعر",
  effort_low: "منخفض",
  effort_medium: "متوسط",
  effort_high: "عالٍ",
  defaultLevel: "المستوى الافتراضي",
  defaultLevelHint: "يُستخدم عندما لا يختار التاجر مستوى. يجب أن يكون مفعّلًا.",
  enableLevel: "تفعيل {level}",
  saveSettings: "حفظ إعدادات الذكاء الاصطناعي",
  settingsSaved: "تم حفظ إعدادات الذكاء الاصطناعي.",
  invalidSettings: "تعذّرت قراءة الإعدادات. أعد تحميل الصفحة وحاول مجددًا.",

  plansTitle: "حصص الباقات",
  plansDesc: "ما هو مجاني كل شهر لكل باقة. تستخدم الميزات المدفوعة هذه الحصة قبل خصم الأرصدة.",
  freeUsers: "المستخدمون المجانيون",
  inactive: "غير نشط",
  freePrompts: "طلبات مجانية / شهر",
  freeCallMinutes: "دقائق مكالمات مجانية / شهر",
  freeImages: "صور مجانية / شهر",
  maxLevel: "أعلى مستوى",
  savePlan: "حفظ",
  planSaved: "تم حفظ الحصة.",
  noPlans: "لا توجد باقات بعد.",

  packsTitle: "حزم الأرصدة",
  packsDesc: "حزم يمكن للتجار شراؤها بالبطاقة (Stripe Checkout على حساب المنصة).",
  addPack: "إضافة حزمة",
  editPack: "تعديل",
  editPackTitle: "تعديل حزمة الأرصدة",
  newPackTitle: "حزمة أرصدة جديدة",
  colPack: "الحزمة",
  colPrice: "السعر",
  colCredits: "الأرصدة",
  colBonus: "المكافأة",
  colBadge: "الشارة",
  colStatus: "الحالة",
  colOrder: "الترتيب",
  packLabel: "التسمية",
  packLabelHint: "اختياري، مثل «حزمة البداية».",
  packCurrency: "العملة",
  packPrice: "السعر",
  packCredits: "الأرصدة",
  packBonus: "أرصدة إضافية",
  packBadge: "الشارة",
  badgeNone: "بدون",
  badge_popular: "الأكثر شيوعًا",
  badge_best_value: "أفضل قيمة",
  packActive: "متاحة للشراء",
  packOrder: "ترتيب العرض",
  savePack: "حفظ الحزمة",
  packSaved: "تم حفظ حزمة الأرصدة.",
  noPacks: "لا توجد حزم أرصدة بعد. أضف واحدة ليتمكن التجار من شراء الأرصدة.",
  active: "نشطة",
  untitledPack: "{credits} رصيد",

  userCreditsTitle: "الأرصدة",
  userCreditsDesc: "محفظة أرصدة الذكاء الاصطناعي لهذا الحساب.",
  balance: "الرصيد",
  purchased: "المشتراة",
  spent: "المستهلكة",
  granted: "الممنوحة",
  noAccount: "لا توجد محفظة بعد — تُنشأ أول مرة يستخدم فيها هذا المستخدم الذكاء الاصطناعي أو يتلقى أرصدة.",
  recentLedger: "الحركات الأخيرة",
  colWhen: "التاريخ",
  colKind: "النوع",
  colChange: "التغيير",
  colBalanceAfter: "الرصيد بعد",
  colReason: "السبب",
  kind_signup: "مكافأة التسجيل",
  kind_purchase: "شراء",
  kind_spend: "استخدام",
  kind_refund: "استرداد",
  kind_admin: "تعديل إداري",
  noLedger: "لا توجد حركات أرصدة بعد.",
  adjustTitle: "تعديل الأرصدة",
  adjustDelta: "الأرصدة",
  adjustDeltaHint: "موجب للإضافة، سالب للخصم (مثل 500 أو ‎-200).",
  adjustReason: "السبب",
  adjustReasonHint: "مطلوب — يُسجَّل في السجل وسجل التدقيق.",
  adjustSubmit: "تطبيق التعديل",
  adjustDone: "تم تعديل الأرصدة. الرصيد الجديد: {balance}.",
  adjustInvalid: "أدخل عددًا صحيحًا من الأرصدة غير الصفر.",
  adjustReasonRequired: "السبب مطلوب.",
};

export default ar;
